import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "convic_token";

export const tokenStore = {
  get() {
    // Migrate any legacy localStorage token to sessionStorage once, then drop it.
    try {
      const legacy = localStorage.getItem(TOKEN_KEY);
      if (legacy) {
        if (!sessionStorage.getItem(TOKEN_KEY)) sessionStorage.setItem(TOKEN_KEY, legacy);
        localStorage.removeItem(TOKEN_KEY);
      }
    } catch {}
    return sessionStorage.getItem(TOKEN_KEY);
  },
  set(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
  },
  clear() {
    sessionStorage.removeItem(TOKEN_KEY);
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
  },
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(fileId, opts = {}) {
  if (!fileId) return null;
  const token = tokenStore.get();
  const params = new URLSearchParams({ token: token || "" });
  if (opts.download) params.set("download", "1");
  return `${API}/files/${fileId}?${params.toString()}`;
}

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Eroare necunoscută";
}
